import {
  Component,
  PLATFORM_ID,
  NgZone,
  ViewChildren,
  QueryList,
  ElementRef,
  ChangeDetectorRef,
  AfterViewInit,
  OnInit,
  Renderer2,
  RendererStyleFlags2,
  ViewChild,
} from '@angular/core';
import {
  AngularfirestoreCoolStoreService,
  AngularfirestorePerfectStoreService,
} from './services/angularfirestore-extension.service';
import { Observable } from 'rxjs';
import { FirebaseService } from './services/firebase.service';
const customer = 'kunde1001';

import { AngularFirestore } from 'angularfire2/firestore';
import { CustomerdatabaseService } from './services/customerdatabase.service';
import { ProfileService } from './services/profile.service';
import { TutorialService } from './services/tutorial.service';
import { Router } from '@angular/router';
import { AuthService } from './services/auth.service';
import { TranslationObject } from './helper/TranslationObject';
import { MenuService } from './services/menu-service';
import { MenuController, Platform } from '@ionic/angular';
import { IndexeddbService } from './services/indexeddb.service';
import { profile } from 'console';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements AfterViewInit, OnInit {
  logoBig = '../assets/mona_white_logo.png';
  logoSmall = '../assets/mona.PNG';
  public loginFinished = false;
  ProfileIcon = '';
  coolClctn$: Observable<any>;
  perfectClctn$: Observable<any>;
  currentUser: any;
  intern = false;
  isAuthenticated: boolean = true;
  admin = '';
  adminBool = false;
  translationObject: any;
  creditsRemaining: number;
  public applicantsRemaining: number;
  enterprise = false;
  currentPlan = '';
  profilePicture = '../assets/icon/megaphone-outline.png';
  public appPages = [];
  public personalButtons = [
    // { title: "WasGibtsNeues", url: '/news', photo: '../assets/icon/megaphone-outline.png' },
    // { title: "NeustartTutorial", url: '/dashboard', photo: '../assets/icon/tutorial.png' },
    // { title: 'HowToVideos', url: '/howto', photo: '../assets/icon/play-skip-forward-outline.png' },
    // { title: 'Hilfe', url: '/help', photo: '../assets/icon/help-circle-outline.png' },
    // { title: 'AccountEinstellungen', url: '/profile', photo: '../assets/icon/settings-outline.png' },
    { title: 'AccountEinstellungen', url: '/profile', icon: 'settings' },
  ];
  //
  @ViewChildren('itemRef', { read: ElementRef })
  itemRefs: QueryList<ElementRef>;
  @ViewChild('mainOutlet', { read: ElementRef }) outlet: ElementRef;

  monaPlatform: boolean = true;
  monaWorkforce: boolean = true;
  monaSupport: boolean = false;
  monaAutomations: boolean = false;
  collapsed: boolean = false;

  // to hold the click event that opens each popover
  platformEvent: any;
  workforceEvent: any;
  automationsEvent: any;
  supportEvent: any;

  businessName: string = '';
  lastLogin: any;
  currentItemName: string = 'Dashboard';
  currentUserExample = {
    name: 'Jane Doe',
    profilePicture: '../assets/icon/megaphone-outline.png', // Leave empty to display initials
  };
  businessLogo: string = '../assets/icon/mona.PNG';
  businessNameOnlyFirstLetter: string = '';
  public iconsOnly = false;

  ngOnInit() { }

  // when user picks a platform page
  onPlatformSelect(title: string) {
    const p = this.appPages.find(x => x.title === title);
    if (p) {
      // Mark applicants as viewed if navigating to Kandidaten page
      if (p.title === 'Kandidaten') {
        this.markApplicantsAsViewed();
      }
      this.router.navigate([p.url]);
    }
  }
  // workforce options
  onWorkforceSelect(val: string) {
    if (val === 'assistant') this.openMONAChat();
    else if (val === 'agents') this.openAIAgents();
  }
  // automations options
  onAutomationsSelect(val: string) {
    if (val === 'datatransfer') this.openDataWarehouse();
    else if (val === 'integrationen') this.integrations();
  }
  // community/support options
  onSupportSelect(val: string) {
    if (val === 'tutorials') this.openTutorials();
    else if (val === 'youtube') this.openYoutube();
    else if (val === 'support') this.openMONASupportLink();
  }

  toggleCollapse() { this.collapsed = !this.collapsed; }

  ngAfterViewInit() {
    console.log('runs first');
    const admin = this.authService.returnUserRole();
    this.admin = admin;
    this.enterprise = true;
    this.adminBool = admin == 'admin' ? true : false;
    console.log('admin', admin);
    setTimeout(() => {
      this.applyMenuState();
    }, 300);
    this.itemRefs.forEach((itemRef) => {
      if (itemRef.nativeElement.innerText == 'Stellenanzeigen') {
        const currentPage = this.router.url;
        const node = itemRef.nativeElement;
        this.authService.setData(node);
        console.log(node);
      }
    });
    this.authService.isAuthenticated$.subscribe((isAuthenticated) => {
      this.isAuthenticated = isAuthenticated;
      if (this.isAuthenticated && this.router.url.includes('dashboard')) {
        this.chooseSubItem('Dashboard');
        document.getElementById('Dashboard').style.backgroundColor = '#F6F6F6';
        let userRole = this.authService.returnUserRole();
        console.log('userRole', userRole);
      }
      this.cdr.detectChanges();
    });
    // this.menuService.AccountSettings$.subscribe((settings) => {
    //   this.personalButtons = settings;
    // });
  }
  public menuCollapsed = false;

  // Variables for notifications
  newApplicantsCount = 10; // Will store how many new applicants arrived
  newMatchesCount = 10; // Will store how many new applicants arrived
  showNewApplicantsToast = true; // Controls if the popup/toast is shown
  lastApplicantsCount = 0; // Keep track of old count to compare
  showGlobalBar = 'false'; // Boolean to show the global bar
  newTutorials = false; // Boolean to indicate new tutorials
  newIntegrations = false; // Boolean to indicate new integrations
  selfserviceRecruiting = false; // Boolean to indicate self-service recruiting
  applicantsViewed = false; // Flag to track if user has viewed applicants

  constructor(
    private profileService: ProfileService,
    private tutorialService: TutorialService,
    private menuCtrl: MenuController,
    private platform: Platform,
    private router: Router,
    private renderer: Renderer2,
    private authService: AuthService,
    private cdr: ChangeDetectorRef,
    private firebaseService: FirebaseService,
    private el: ElementRef,
    private menuService: MenuService,
    private customerDB: CustomerdatabaseService,
    private indexeddbService: IndexeddbService
  ) {
    this.translationObject = TranslationObject.TRANSLATION_OBJECT;
    this.menuService.menuCompanyLogo$.subscribe((logo) => {
      this.businessLogo = logo;
    });
    this.menuService.menuItems$.subscribe(async (items) => {
      this.appPages = items;
      this.checkIfSalesAccount();
    });
    this.menuService.userRole$.subscribe((plan) => {
      this.currentPlan = plan;
      this.loadGlobalBar();
      console.log('currentPlan', this.currentPlan);
      if (
        this.currentPlan == 'free' ||
        this.currentPlan == 'starter' ||
        this.currentPlan == 'wachstum'
      ) {
        this.loadGlobalBar();
      }
      if (this.currentPlan.includes('self-service')) {
        this.selfserviceRecruiting = true;
        this.menuService.setMenuForRole('self-service-recruiting');
        this.monaWorkforce = false;
      }
    });
    this.menuService.planLimits$.subscribe((plan) => {
      this.applicantsRemaining = plan.applicantsRemaining || 0;
      if (
        this.applicantsRemaining != undefined &&
        this.applicantsRemaining > 0
      ) {
        this.loadGlobalBar();
      } else {
        // this.showGlobalBar = "false";
      }
      if (plan.planName == 'agents') {
        this.loadGlobalBar();
      }
    });
  }

  async loadGlobalBar() {
    await this.creditsRefresh();
    await this.getBusinessName();
    const margin = "56px";
    this.renderer.setStyle(this.outlet.nativeElement, 'margin-top', margin);
    this.showGlobalBar = 'true';
  }

  toggleIconMenu() {
    this.iconsOnly = !this.iconsOnly;

    // Save the state to localStorage
    localStorage.setItem('menuIconsOnly', this.iconsOnly.toString());

    // Apply the state
    this.applyMenuState();

    // Ensure tooltips work after toggling
    setTimeout(() => {
      this.ensureTooltipsWork();
    }, 100);
  }

  ensureTooltipsWork() {
    if (this.iconsOnly) {
      // Get all menu items
      const menuItems = document.querySelectorAll('.menu-item');
      const menuTitles = document.querySelectorAll('.menu-title');

      // Process menu items
      menuItems.forEach(item => {
        const label = item.querySelector('.responsive-label');
        if (label && !item.hasAttribute('data-tooltip')) {
          // Get text content and trim whitespace
          const labelText = label.textContent?.trim();
          if (labelText) {
            item.setAttribute('data-tooltip', labelText);
          }
        }
      });

      // Process menu titles
      menuTitles.forEach(title => {
        const label = title.querySelector('.menu-label');
        if (label && !title.hasAttribute('data-tooltip')) {
          // Get text content and trim whitespace
          const labelText = label.textContent?.trim();
          if (labelText) {
            title.setAttribute('data-tooltip', labelText);
          }
        }
      });

      // Make sure ion-menu and ion-content have overflow visible
      const menu = document.querySelector('ion-menu');
      const content = document.querySelector('ion-menu ion-content');

      if (menu) {
        menu.setAttribute('style', menu.getAttribute('style') + '; overflow: visible !important');
      }

      if (content) {
        content.setAttribute('style', content.getAttribute('style') + '; overflow: visible !important');
      }
    }
  }

  loadMenuState() {
    const savedState = localStorage.getItem('menuIconsOnly');
    if (savedState) {
      this.iconsOnly = savedState === 'true';
    }
  }

  applyMenuState() {
    // First get direct references to all menu elements
    const menu = document.querySelector('ion-menu');
    const splitPane = document.querySelector('ion-split-pane');
    const routerOutlet = document.querySelector('ion-router-outlet');
    const ionApp = document.querySelector('ion-app');

    if (!menu || !splitPane) return;

    // open all menus first
    this.monaWorkforce = true;
    this.monaAutomations = true;
    this.monaSupport = true;
    this.monaPlatform = true;
    if (this.iconsOnly) {
      // 1. Close the menu first to avoid transition glitches
      this.menuCtrl.close('main-menu');

      // 2. Add the collapsed-menu class
      menu.classList.add('collapsed-menu');
      splitPane.classList.add('menu-collapsed');

      if (ionApp) {
        ionApp.classList.add('menu-collapsed');
      }

      // 3. Directly set inline styles on key elements
      menu.setAttribute('style', 'width: 64px !important; max-width: 64px !important; min-width: 64px !important; overflow: visible !important;');

      // 4. Adjust the router-outlet
      if (routerOutlet) {
        routerOutlet.setAttribute('style', 'width: calc(100% - 64px) !important; margin-left: 64px !important;');
      }

      // 5. Wait a brief moment and then make another pass to catch any elements
      //    that might have been changed by Ionic's internal processes
      setTimeout(() => {
        this.forceAllMenuElementWidths(64);
        this.fixContentWidths(64);
      }, 50);

      // 6. Do another pass after layout has settled
      setTimeout(() => {
        this.forceAllMenuElementWidths(64);
        this.fixContentWidths(64);
        // Force resize event
        window.dispatchEvent(new Event('resize'));
      }, 300);
    } else {
      // 1. Remove the collapsed-menu class
      menu.classList.remove('collapsed-menu');
      splitPane.classList.remove('menu-collapsed');

      if (ionApp) {
        ionApp.classList.remove('menu-collapsed');
      }

      // 2. Reset inline styles
      menu.setAttribute('style', 'width: 300px !important; max-width: 300px !important; min-width: 300px !important;');

      // 3. Adjust the router-outlet
      if (routerOutlet) {
        routerOutlet.setAttribute('style', 'width: calc(100% - 300px) !important; margin-left: 300px !important;');
      }

      // 4. Follow-up to catch any elements changed by Ionic
      setTimeout(() => {
        this.forceAllMenuElementWidths(300);
        this.fixContentWidths(300);
      }, 50);

      // 5. Do another pass after layout has settled
      setTimeout(() => {
        this.forceAllMenuElementWidths(300);
        this.fixContentWidths(300);
        // Force resize event
        window.dispatchEvent(new Event('resize'));
      }, 300);
    }
  }

  forceAllMenuElementWidths(width: number) {
    // Target all possible menu-related elements
    const selectors = [
      'ion-menu',
      'ion-menu-inner',
      '.menu-inner',
      '.split-pane-side',
      '.menu-content'
    ];

    selectors.forEach(selector => {
      const elements = document.querySelectorAll(selector);
      elements.forEach(el => {
        (el as HTMLElement).style.width = `${width}px`;
        (el as HTMLElement).style.maxWidth = `${width}px`;
        (el as HTMLElement).style.minWidth = `${width}px`;

        // Set important flag by using cssText
        (el as HTMLElement).style.cssText += `; width: ${width}px !important; max-width: ${width}px !important; min-width: ${width}px !important;`;

        // Add overflow visible for tooltips when collapsed
        if (width === 64) {
          (el as HTMLElement).style.cssText += '; overflow: visible !important;';
        }
      });
    });
  }

  fixContentWidths(menuWidth: number) {
    // Update the router outlet
    const routerOutlet = document.querySelector('ion-router-outlet');
    if (routerOutlet) {
      (routerOutlet as HTMLElement).style.cssText += `; width: calc(100% - ${menuWidth}px) !important; margin-left: ${menuWidth}px !important;`;
    }

    // Target main content containers
    const mainContentSelectors = [
      '.split-pane-main',
      '.ion-page',
      '.ion-page > div'
    ];

    mainContentSelectors.forEach(selector => {
      const elements = document.querySelectorAll(selector);
      elements.forEach(el => {
        // For the main content, we just want to ensure it's 100% wide within its container
        (el as HTMLElement).style.cssText += '; width: 100% !important; max-width: 100% !important; margin-left: 0 !important; left: 0 !important;';
      });
    });

    // Fix any explicit width elements in the content area
    const contentElements = document.querySelectorAll('ion-router-outlet [style*="width"]');
    contentElements.forEach(el => {
      if (!(el as HTMLElement).style.cssText.includes('100%')) {
        // Only adjust if it's not already set to 100%
        (el as HTMLElement).style.maxWidth = '100%';
      }
    });
  }

  checkIfSalesAccount() {
    // let userEmail = this.authService.returnUser();
    // if (
    //   userEmail == 'sales@mona-ai.de' ||
    //   userEmail == 'sales@mona-ai.fr' ||
    //   userEmail == 'sales@mona-ai.co.uk' ||
    //   userEmail == 'sales@mona-ai.it'
    // ) {
    let url = window.location.href;
    if (url.includes("staging-mona") || url.includes("localhost")) {
      this.appPages.push({
        title: this.translationObject['Einzelkontaktierung'],
        url: '/contact-form',
        photo: '../assets/flaticons_white/contact-mail.png',
      });
    }
    // }
  }

  async logout() {
    try {
      document.cookie = `MONAPlatformToken=; path=/; max-age=0; Secure; SameSite=Strict`;
    } catch (err) { }
    localStorage.clear();
    await this.authService.logOut();
  }

  goToProfile() {
    this.router.navigateByUrl('/profile');
  }

  goToSettings() {
    this.router.navigateByUrl('/settings');
  }

  goToPricing() {
    this.router.navigateByUrl('/pricing');
  }

  private checkForNewMatches() {
    // this.tutorialService.getNewMatches().then((newMatches) => {
    //   this.newMatchesCount = newMatches;
    // });
    if (this.businessName == '') {
      return;
    }

    let milliseconds =
      this.lastLogin.seconds * 1000 + this.lastLogin.nanoseconds / 1000000;
    let queryDate = new Date(milliseconds);
    if (false) {
      this.firebaseService
        .returnSalesEmailsNormalCustomers(this.businessName)
        .get()
        .then((snap) => {
          let matches = snap.docs.map((doc) => {
            let data = doc.data();
            data.id = doc.id;
            return data;
          });
          console.log(matches);
          let newMatches = [];
          this.firebaseService.saveEmailsToBeSentLocally(matches);
          matches.forEach((match) => {
            if (match.created) {
              let created = new Date(match.created);
              if (created > queryDate) {
                newMatches.push(match);
              }
            }
          });
          this.newMatchesCount = newMatches.length;
          if (this.newMatchesCount > 0) {
            this.appPages.forEach((element) => {
              if (element.title == 'Kommunikation') {
                element.showNewBadge = true;
              }
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  private async listenToApplicants() {
    // get the date from last login
    // then get applicants with date "created" after last login
    // then set the newApplicantsCount
    let lastLogin = await this.firebaseService.returnLastLogin();
    console.log('lastLogin', lastLogin);
    let loginData = lastLogin.data().lastLogin;
    if (loginData == undefined || loginData == null) {
      this.firebaseService.updateLastLogin(this.authService.returnUserId());
      return;
    }
    console.log('lastLogin', loginData);
    let milliseconds =
      loginData.seconds * 1000 + loginData.nanoseconds / 1000000;
    let queryDate = new Date(milliseconds);
    console.log('queryDate', queryDate);
    this.customerDB
      .getApplicantsAfterDate(queryDate)
      .get()
      .then((snap) => {
        let applicants = snap.docs.map((doc) => doc.data());
        this.newApplicantsCount = applicants.length;
        this.firebaseService.updateLastLogin(this.authService.returnUserId());
        console.log('newApplicantsCount', this.newApplicantsCount);
        if (this.newApplicantsCount > 0) {
          this.appPages.forEach((element) => {
            if (element.title == 'Kandidaten') {
              element.showNewBadge = true;
            }
          });
        }
      });
  }

  private checkForNewTutorials() {
    // this.tutorialService.getNewTutorials().then((newTutorials) => {
    //   this.newTutorials = newTutorials;
    // });
  }

  private checkForNewIntegrations() {
    // this.tutorialService.getNewIntegrations().then((newIntegrations) => {
    //   this.newIntegrations = newIntegrations;
    // });
  }

  public markApplicantsAsRead() {
    // Don't reset the badge on click
    // Instead, mark it to be reset when user actually views the page
    event.stopPropagation(); // Prevent navigation
  }

  // New method to mark applicants as viewed when navigating to candidates page
  private markApplicantsAsViewed() {
    this.applicantsViewed = true;
    this.newApplicantsCount = 0;
    this.firebaseService.updateLastLogin(this.authService.returnUserId());
    // Reset badge for Kandidaten menu item
    this.appPages.forEach(element => {
      if (element.title == 'Kandidaten') {
        element.showNewBadge = false;
      }
    });
  }

  routePricing() {
    this.router.navigateByUrl('/pricing');
  }

  public markMatchesAsRead() {
    this.firebaseService.markMatchesAsRead();
    this.newMatchesCount = 0;
  }

  creditsRefresh() {
    this.customerDB.retreiveUserCreditsAllTheTimeUpToDate((credits) => {
      console.log('User credits updated:', credits);
      this.creditsRemaining = credits;
    });
  }

  toggleMenu() {
    this.menuCollapsed = !this.menuCollapsed;
  }

  toggle(section: 'platform' | 'workforce' | 'automations' | 'support') {
    this.monaPlatform = section === 'platform' ? !this.monaPlatform : false;
    this.monaWorkforce = section === 'workforce' ? !this.monaWorkforce : false;
    this.monaAutomations = section === 'automations' ? !this.monaAutomations : false;
    this.monaSupport = section === 'support' ? !this.monaSupport : false;
  }

  manageSubscription() {
    this.router.navigateByUrl('/pricing');
  }

  async getBusinessName() {
    this.businessName = this.customerDB.returnBusinessName();
    if (this.businessName == undefined || this.businessName == null || this.businessName == '') {
      return;
    }
    this.customerDB
      .getProfile()
      .get()
      .then((data) => {
        if (data.docs.length == 0) {
          return;
        } else {
          let profileData = data.docs[0].data();
          if (profileData.companyLogo != undefined && profileData.companyLogo != null && profileData.companyLogo != '') {
            if (profileData.companyLogo.startsWith('http')) {
              this.businessLogo = profileData.companyLogo;
            } else {
              this.businessLogo = 'data:image/jpeg;base64,' + profileData.companyLogo;
            }
          } else {
            this.businessLogo = undefined;
          }
        }
      });
    this.businessNameOnlyFirstLetter = this.businessName.charAt(0);
    console.log(
      'businessNameOnlyFirstLetter',
      this.businessNameOnlyFirstLetter,
    );
    this.lastLogin = await this.getLastLogin();
    this.checkForNewMatches();
    this.listenToApplicants();
    this.checkForNewTutorials();
    this.checkForNewIntegrations();
  }

  async getLastLogin() {
    let lastLogin = await this.firebaseService.returnLastLogin();
    console.log('lastLogin', lastLogin);
    let loginData = lastLogin.data().lastLogin;
    if (loginData == undefined || loginData == null) {
      await this.firebaseService.updateLastLogin(
        this.authService.returnUserId(),
      );
      this.getLastLogin();
    }
    return loginData;
  }

  openMONASupportLink() {
    window.open(
      'https://calendly.com/mona-vertrieb/mona-ai-onboarding-support',
    );
  }

  openDocumentation() {
    window.open('https://docs.mona-ai.de/');
  }

  openMONAChat() {
    this.chooseSubItem('chatMonaBeta');
    this.router.navigateByUrl('/mona-agent-chat');
  }

  openAIAgents() {
    this.chooseSubItem('chatAgentenBeta');
    this.router.navigateByUrl('/agents');
  }

  openAgentBuilder() {
    this.chooseSubItem('agentBuilder');
    this.router.navigateByUrl('/mona-agent-builder');
  }

  dataImport() {
    this.router.navigateByUrl('/upload');
  }

  blacklist() {
    this.router.navigateByUrl('/blacklist');
  }

  integrations() {
    this.newIntegrations = false;
    this.router.navigateByUrl('/integrations');
  }

  getCurrentUser() {
    var currentUser = this.authService.returnUser();
    this.currentUser = currentUser;
    if (this.currentUser != 'admin@mona-ai.de') {
      this.appPages.splice(1, 6);
    }
    console.log(currentUser);
  }

  navigateToFeedbackUrl() {
    window.open('https://www.mona-ai.de/kontakt');
  }

  openYoutube() {
    window.open('https://www.youtube.com/channel/UCZUycJcsFxQAE52kaYi52xg');
  }

  openTutorials() {
    this.router.navigateByUrl('/video-library');
  }

  openDataWarehouse() {
    this.router.navigateByUrl('/data-warehouse');
  }

  backToDashboard() {
    this.router.navigateByUrl('/dashboard');
  }

  switchMonaPlatform() {
    // If in collapsed mode, don't expand the section
    if (this.iconsOnly) {
      // Instead, navigate to the first page in the platform section if available
      if (this.appPages.length > 0) {
        this.router.navigate([this.appPages[0].url]);
      }
      return;
    }

    // Regular behavior when not in collapsed mode
    this.monaPlatform = !this.monaPlatform;
  }

  // Updated switchMonaWorkforce method
  switchMonaWorkforce() {
    // If in collapsed mode, navigate to MONA Assistant
    if (this.iconsOnly) {
      this.openMONAChat();
      return;
    }

    // Regular behavior when not in collapsed mode
    this.monaWorkforce = !this.monaWorkforce;
  }

  // Updated switchMonaSupport method
  switchMonaSupport() {
    // If in collapsed mode, open tutorials
    if (this.iconsOnly) {
      this.openTutorials();
      return;
    }

    // Regular behavior when not in collapsed mode
    this.monaSupport = !this.monaSupport;
  }

  // Updated switchToMONAAutomations method
  switchToMONAAutomations() {
    // If in collapsed mode, go to integrations
    if (this.iconsOnly) {
      this.integrations();
      return;
    }

    // Regular behavior when not in collapsed mode
    this.monaAutomations = !this.monaAutomations;
  }

  mouseenter(name: string, monaDiv: HTMLDivElement) {
    switch (name) {
      case 'MONA Platform':
        monaDiv.style.backgroundColor = '#F6F6F6';
        break;
      case 'MONA Workforce':
        monaDiv.style.backgroundColor = '#F6F6F6';
        break;
      case 'Support':
        monaDiv.style.backgroundColor = '#F6F6F6';
        break;

      default:
        break;
    }
  }

  mouseleave(name: string, monaDiv: HTMLDivElement) {
    switch (name) {
      case 'MONA Platform':
        monaDiv.style.backgroundColor = 'white';
        break;
      case 'MONA Workforce':
        monaDiv.style.backgroundColor = 'white';
        break;
      case 'Support':
        monaDiv.style.backgroundColor = 'white';
        break;

      default:
        break;
    }
  }

  appmouseenter(name: string) {
    document.getElementById(name).style.backgroundColor = '#EEEEEE';
  }

  appmouseleave(name: string) {
    if (name == this.currentItemName) {
      document.getElementById(name).style.backgroundColor = '#F6F6F6';
    } else {
      document.getElementById(name).style.backgroundColor = 'white';
    }
  }

  settingmouseenter(name: string) {
    document.getElementById(name).style.backgroundColor = '#072966';
  }

  settingmouseleave(name: string) {
    document.getElementById(name).style.backgroundColor = '#151945';
  }

  chooseSubItem(name: string) {
    console.log('name', name);
    this.currentItemName = name;

    // Mark applicants as viewed if navigating to Kandidaten
    if (name === 'Kandidaten') {
      this.markApplicantsAsViewed();
    }

    // this.appPages.forEach(element => {
    //   if (element.title == name) {
    //     document.getElementById(element.title).style.backgroundColor = "#EEEEEE";
    //   }
    //   else {
    //     document.getElementById(element.title).style.backgroundColor = "white";
    //   }
    // });

    // let menuEntry = this.appPages.find(element => element.title == name)
    // if (menuEntry != undefined) {
    //   menuEntry.showNewBadge = false;
    // }

    // if (name == "chatMonaBeta") {
    //   document.getElementById("chatMonaBeta").style.backgroundColor = "#EEEEEE";
    // }
    // else {
    //   document.getElementById("chatMonaBeta").style.backgroundColor = "white";
    // }

    // if (name == "chatAgentenBeta") {
    //   document.getElementById("chatAgentenBeta").style.backgroundColor = "#EEEEEE";
    // }
    // else {
    //   document.getElementById("chatAgentenBeta").style.backgroundColor = "white";
    // }

    // if (name == "Tutorials") {
    //   document.getElementById("Tutorials").style.backgroundColor = "#EEEEEE";
    // }
    // else {
    //   document.getElementById("Tutorials").style.backgroundColor = "white";
    // }
  }
}
